export default "__VITE_ASSET__p_nO9yKo__"